import type { GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import ServicesStudentPage from '../../components/ServicesForStudent';
import fetchUtil from '../../utils/fetchUtil';

const StudentServices: NextPage = (props: any) => {
  const { meta } = props?.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#FBBFB6');
    customStyle.setProperty('--navbar-menu-color', '#0E1B2C')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <ServicesStudentPage {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/services-students`, 'GET', {}, '', false)
  return {
    props: {
      pageData,
    }
  };
}

export default StudentServices;